module.exports = {
  'en-CA': 'yyyy-mm-dd',
  'en-GB': 'dd/mm/yyyy',
  'en-IE': 'dd/mm/yyyy',
  'en-US': 'mm/dd/yyyy',
  'es-ES': 'dd/mm/aaaa',
  'es-MX': 'dd/mm/aaaa',
  'fr-FR': 'jj/mm/aaaa',
  'hi-IN': 'dd-mm-yyyy',
  'zh-CN': 'YYYY-MM-DD',
  'es-US': 'yyyy-mm-dd',
  'es-CL': 'dd-mm-yyyy',
  'pt-BR': 'dd/mm/aaaa',
  'fr-CA': 'YYYY-MM-DD',
}
